module.exports = __webpack_public_path__ + "f80e745787cb9633e7b6fa5002cdf507.png";